import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import pickRatio from 'emun.on-demand/design-ratio-picker'

class DesignerToolbarController {
    constructor() {
        basicController(this)
        const $ctrl = this;
    }
    setArtboardRatio(ratio){
        this.designer.resize(ratio.width, ratio.height)
    }
    openRatioPicker(){
        pickRatio(this.designer.design).then(r => this.setArtboardRatio(r));
    }
}

export default DesignerToolbarController;